import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box, Button, Menu, MenuItem, TableBody, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { useState } from 'react';
import axios from 'axios'
import Swal from 'sweetalert2';
import { FaEdit, FaMapMarkerAlt, FaMarker, FaTrash, FaUser, FaUserAlt } from 'react-icons/fa';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import Fade from '@mui/material/Fade';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import moment from 'moment';


export default function PurchaseEntry() {

    const [managerName, setManagerName] = useState()
    const [projectName, setProjectName] = useState()
    const [desc, setDesc] = useState()
    const [location, setLocation] = useState()
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [id, setId] = useState()

    const [pno, setPno] = useState()
    const [pdate, setPdate] =  useState('')
    const [supName, setSupName] = useState('')
    const [product, setProduct] = useState('')
    const [qty, setQty] = useState()
    const [sbr, setSbr] = useState('')
    const [uom, setUom] = useState('')





    const add_basic = () => {
        axios.post("https://buildfastvapi.emedha.in/pmaster/api/v1/add/purchasentry", {
            pentry:pno,pdate,supplier_name:supName,Product:product,UOM:uom,Quanitity:qty,Spplier_bill_Ref:sbr
        }).then((res) => {
            if (res.data.status === 200) {
                setOpen(false)
                Swal.fire({
                    icon: 'success',
                    title: "Success !",
                    text: "Data added successfully !",
                    confirmButtonColor: "rgb(126, 110, 228)",
                    cancelButtonColor: "#d33",
                    showCancelButton: false,
                    confirmButtonText: "Ok"
                }).then((result) => {
                    if (result.value) {
                        return
                    }
                })
            }
        })
    }

    const [response, setResponse] = useState([])

    const get_basic = () => {
        axios.get("https://buildfastvapi.emedha.in/project/api/v1/get-basic").then((res) => {
            if (res.data.status === 200) {
                setResponse(res.data.data)
            }
        })
    }

    React.useEffect(() => {
        get_basic()
    }, [])

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open2 = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event);
        setOpen1(open1)
    };

    const handleClose2 = () => {
        setAnchorEl(null);
        setOpen1(false);
    };

    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false);
        setValidated(false)
    };

    const [Validated, setValidated] = useState(false);

    const formValidation = (event) => {
        event.preventDefault()
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            add_basic()
        }

        setValidated(true);
    };

    const deleteAlert = (id) => {
        handleClose2()
        Swal.fire({
            icon: 'warning',
            title: "Warning !",
            text: "Are sure to delete this data",
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: true,
            confirmButtonText: "Delete"
        }).then((result) => {
            if (result.value) {
                basicDataDelete(id)
            }
        })
    }

    const basicDataDelete = (id) => {
        axios.post('https://buildfastvapi.emedha.in/pmaster/api/v1/del/purchentr', {
            Id:id
        }).then((res) => {
            if (res.data.status === 200) {
                get_alldata()
                Swal.fire({
                    icon: 'success',
                    title: "Successfull !",
                    text: "Basic is deleted successfully !",
                    confirmButtonColor: "rgb(126, 110, 228)",
                    cancelButtonColor: "#d33",
                    showCancelButton: false,
                    confirmButtonText: "Ok"
                }).then((result) => {
                    if (result.value) {
                        return
                    }
                })
            }
        })
    }

    const editAlert = () => {
        setOpen1(false)
        handleCloseed()
        Swal.fire({
            icon: 'warning',
            title: "Warning !",
            text: "Are sure to edit this data",
            confirmButtonColor: "green",
            cancelButtonColor: "#d33",
            showCancelButton: true,
            confirmButtonText: "Edit"
        }).then((result) => {
            if (result.value) {
                basicDataEdit(id)
            }
        })
    }

    const basicDataEdit = (id) => {
        axios.post('https://buildfastvapi.emedha.in/pmaster/api/v1/purchasentry/edit', {
            pentry:pno,pdate,supplier_name:supName,Product:product,UOM:uom,Quanitity:qty,Spplier_bill_Ref:sbr,Id:id
        }).then((res) => {
            if (res.data.status === 200) {
                    setOpen(false)
                    get_alldata()
                    Swal.fire({
                        icon: 'success',
                        title: "Successfull !",
                        text: "Basic is updated successfully !",
                        confirmButtonColor: "rgb(126, 110, 228)",
                        cancelButtonColor: "#d33",
                        showCancelButton: false,
                        confirmButtonText: "Ok"
                    }).then((result) => {
                        if (result.value) {
                            return
                        }
                    })
                
            }
        })
    }

    const [open1, setOpen1] = useState(false)

    const viewData = () => {
        axios.post('https://buildfastvapi.emedha.in/pmaster/api/v1/view-purchentry', {
            Id:id
        }).then((res) => {
            setPno(res.data.pentry)
            setPdate(res.data.pdate)
            setSupName(res.data.supplier_name)
            setProduct(res.data.Product)
            setQty(res.data.Quanitity)
            setUom(res.data.UOM)
            setSbr(res.data.Spplier_bill_Ref)
            setOpen1(true)
        })
    }

    const searchBasic = (text) => {
        axios.post('https://buildfastvapi.emedha.in/project/api/v1/search-basic', {
            text
        }).then((res) => {

            setResponse(res.data)

        })
    }

   

    

    const [opened, setOpened] = React.useState(false);

  const handleClickOpened = () => {
    setOpened(true);
  };

  const handleCloseed = () => {
    setOpened(false);
  };

  const [response1, setResponse1] = useState([])

  const get_prom = () => {
      axios.get("https://buildfastvapi.emedha.in/pmaster/api/v1/get-prouom").then((res) => {
          if (res.data.status === 200) {
              setResponse1(res.data.data)
          }
      })
  }

  const [response2, setResponse2] = useState([])

  const get_alldata = () => {
      axios.get("https://buildfastvapi.emedha.in/pmaster/api/v1/purchase-getall").then((res) => {
          if (res.data.status === 200) {
              setResponse2(res.data.data)
          }
      })
  }

  React.useEffect(() => {
      get_prom()
      get_alldata()
     
  }, [])

    return (
        <div>

            <div >
                <Paper elevation={0} >

                    <TableContainer sx={{ height: 95 + "vh", p: 0.3, pt: 2 }} >

                      

              
                   <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", sm: "row" }, // Stacks on mobile, side-by-side on tablet/desktop
    justifyContent: "space-between",
    alignItems: { xs: "stretch", sm: "center" }, // Full width on mobile, centered vertically on desktop
    gap: "15px",
    padding: "15px 20px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #E0E5F2",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.02)",
    width: "100%",
    boxSizing: "border-box",
  }}
>
  {/* Left Side: Search Input */}
  <Box sx={{ flex: 1, maxWidth: { xs: "100%", sm: "400px" } }}>
    <input
      onChange={(e) => searchBasic(e.target.value)}
      placeholder="Search purchases..."
      style={{
        width: "100%",
        height: "45px", // Premium, easy-to-tap height
        padding: "0 15px",
        fontSize: "14px",
        color: "#2B3674",
        backgroundColor: "#F4F7FE", // Soft premium background
        border: "1px solid #E0E5F2",
        borderRadius: "8px",
        outline: "none",
        boxSizing: "border-box",
        transition: "border-color 0.2s ease",
      }}
      onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
      onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
    />
  </Box>

  {/* Right Side: Action Button */}
  <Button
    onClick={() => setOpen(true)}
    sx={{
      height: "45px",
      minWidth: "150px",
      width: { xs: "100%", sm: "auto" }, // Full width button on phones, auto-sizes on desktop
      background: "linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)", // Deep theme gradient
      color: "white",
      fontWeight: "700",
      textTransform: "none",
      borderRadius: "8px",
      boxShadow: "0px 4px 12px rgba(67, 24, 255, 0.2)",
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0px 6px 15px rgba(67, 24, 255, 0.3)",
      },
    }}
  >
    + Add Purchase
  </Button>
</Box>

   <TableContainer 
          sx={{ 
            width: 'calc(100% - 32px)', // Accounts for margins
            mx: 2,
            borderRadius: '12px', 
                 border: '1px solid #E0E5F2', 
        marginTop:'20px',
            overflowX: 'auto', // CRITICAL for mobile scrolling
            backgroundColor: '#ffffff',
            maxHeight: '65vh', // Scroll within the page
            '&::-webkit-scrollbar': { height: '6px', width: '6px' },
            '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
          }}
        >
                        <Table style={{ position: 'relative'}}>
                            <TableHead sx={{ borderTop: '1px solid lightgray' , background: 'linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)',
                  boxShadow: '0px 4px 10px rgba(67, 24, 255, 0.15)' }}>
                                <TableRow >
                                    <TableCell
                                        align={"start"}
                                        style={{ minWidth: 0, fontSize: 14, fontWeight: '600', color: '#fff', fontSize: 13 }}
                                    >
                                        Purchase no 
                                    </TableCell>
                                    <TableCell
                                        align={"start"}
                                        style={{ minWidth: 0, fontSize: 14, fontWeight: '600', color: '#fff', fontSize: 13 }}
                                    >
                                        Date
                                    </TableCell>
                                    <TableCell
                                        align={"start"}
                                        style={{ minWidth: 0, fontSize: 14, fontWeight: '600', color: '#fff', fontSize: 13 }}
                                    >
                                        Supplier Name
                                    </TableCell>
                                    <TableCell
                                        align={"start"}
                                        style={{ minWidth: 0, fontSize: 14, fontWeight: '600', color: '#fff', fontSize: 13 }}
                                    >
                                       Product
                                    </TableCell>
                                    <TableCell

                                        align={"start"}
                                        style={{ top: 57, fontWeight: '600', color: '#fff', fontSize: 13 }}
                                    >
                                        Quantity
                                    </TableCell>
                                    <TableCell

                                        align={"left"}
                                        style={{ top: 57, fontWeight: '600', color: '#fff', fontSize: 13 }}
                                    >
                                        UOM
                                    </TableCell>
                                    <TableCell

                                        align={"left"}
                                        style={{ top: 57, fontWeight: '600', color: '#fff', fontSize: 13 }}
                                    >
                                        Supplier bill ref
                                    </TableCell>

                                

                                    <TableCell

                                        align={"left"}
                                        style={{ top: 21, fontWeight: '600', color: '#fff', fontSize: 13, width: 21 }}
                                    >
                                        Action
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {
                                    response2.map(item => (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={item.Id}>
                                        <TableCell align={"start"}
                                            style={{ top: 57 }}>
                                            {item.pentry}
                                        </TableCell>
                                        <TableCell align={"start"}
                                            style={{ top: 57, fontSize: 12 }}>{`${moment(item.pdate).format('DD/MM/yyyy')}`}</TableCell>
                                        <TableCell align={"start"}
                                            style={{ top: 57, fontSize: 12 }}>
                                                {item.supplier_name}
                                        </TableCell>
                                        <TableCell align={"start"}
                                            style={{ top: 57, fontSize: 12 }}>
                                           {item.Product}
                                        </TableCell>
                                        <TableCell align={"start"}
                                            style={{ top: 57, fontSize: 12 }}>{item.Quanitity}</TableCell>
                                        <TableCell align={"start"}
                                            style={{ top: 57, fontSize: 12 }}>{item.UOM}</TableCell>
                                        <TableCell align={"start"}
                                            style={{ top: 57, fontSize: 12 }}>{item.Spplier_bill_Ref}</TableCell>
                                       
                                             <TableCell align={"start"}
                                            style={{ top: 57, fontSize: 12, color: "rgb(126, 110, 228) " }}>

                                            <div style={{ display: 'flex' }} >
                                                {/* <Button  style={{ backgroundColor: 'red', color: 'white', fontSize: 11, height: '1.7rem', position: 'relative', top: '0.4rem', left: '-0.2rem' }} >Delete</Button> */}
                                                <div>
                                                <IconButton
                                                        id="fade-button"
                                                        aria-controls={open2 ? 'fade-menu' : undefined}
                                                        aria-haspopup="true"
                                                        aria-expanded={open2 ? 'true' : undefined}
                                                        onClick={(e) => {
                                                            handleClick(e.currentTarget)
                                                            setId(item.Id)
                                                        }}
                                                    >
                                                        <MoreVertIcon />
                                                    </IconButton>
                                                    <Menu
                                                        id="fade-menu"
                                                        MenuListProps={{
                                                            'aria-labelledby': 'fade-button',
                                                        }}
                                                        anchorEl={anchorEl}
                                                        open={open2}
                                                        onClose={handleClose2}
                                                        TransitionComponent={Fade}
                                                    >

                                                        <MenuItem style={{ color: 'gray' }} onClick={() => {
                                                            handleClickOpened()
                                                            viewData(id)
                                                        }}><FaEdit style={{ marginRight: 4 }} /> Edit</MenuItem>

                                                        <MenuItem onClick={() => deleteAlert(id)} style={{ color: 'gray' }} ><FaTrash style={{ marginRight: 4 }} /> Delete</MenuItem>
                                                    </Menu>
                                                </div>
                                            </div>
                                        </TableCell>


                                       
                                    </TableRow>
                                    ))
                                }

                                        {/* // );
                                    // })} */}
                            </TableBody>
                        </Table>
</TableContainer>

                        {
                            response2.length === 0 && (
                                <Box className='card' style={{ border: 'none', height: '58vh', width: '100%', boxShadow: 'none', justifyContent: 'center', alignItems: 'center' }} >
                                    <img src='https://cdn-icons-png.flaticon.com/128/2291/2291944.png' width='145px' />
                                    <Typography>0 users</Typography>
                                </Box>
                            )
                        }
                    </TableContainer>
                </Paper>
            </div>

            <div>
                <Dialog
                    style={{ borderTop: '12px solid rgb(126, 110, 228)' }}
                    maxWidth='md'
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="responsive-dialog-title"
                >

                    <DialogContent>
                   
                            <Form noValidate validated={Validated} onSubmit={formValidation} >
                                <div className='mb-4 mt-1'>
                                    <Typography style={{ textAlign: 'center', fontWeight: '500', color: 'rgb(126, 110, 228)', fontSize: 21 }}>Add Purchase</Typography>
                                    {/* <Typography style={{ textAlign: 'center', fontSize: 15 }}>Addding project details will receive a privacy audit.</Typography> */}
                                </div>
                                <Row className="mb-3">

                                <Form.Group as={Col} md="6" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Purchase no </Typography>
                                        <Form.Control
                                            required
                                            onChange={(e) => setPno(e.target.value)}
                                           
                                            type="number"

                                            style={{ padding: '0.42rem', marginBottom: 14, }}

                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid supplier name
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}> Date</Typography>
                                        <Form.Control
                                            required
                                          
                                            onChange={(e) => setPdate(e.target.value)}
                                            type="date"

                                            style={{ padding: '0.42rem', marginBottom: 14 }}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid  date
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Supplier Name</Typography>
                                        <Form.Control
                                            required
                                            onChange={(e) => setSupName(e.target.value)}
                                             
                                            type="text"

                                            style={{ padding: '0.42rem', marginBottom: 14, }}

                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid supplier name
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Product</Typography>
                                        <Form.Select
                                            required
                                            onChange={(e) => setProduct(e.target.value)}
                                            type="text"

                                           

                                            style={{ padding: '0.42rem', marginBottom: 14 }}


                                        >
                                            <option>Select Product</option>

                                            {
                                                response1.map((data,index) => (
                                                    <React.Fragment key={index}>
                                                    {data.ProductName.split(',').map((block, blockIndex) => (
                                                        <option key={blockIndex}>{block.trim()}</option>
                                                    ))}
                                                    </React.Fragment>
                                                ))
                                            }

                                            
                                            
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid manager
                                        </Form.Control.Feedback>
                                    </Form.Group>


                                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Quantity</Typography>
                                        <Form.Control
                                            required
                                            onChange={(e) => setQty(e.target.value)}
                                            type="number"

                                            style={{ padding: '0.42rem', marginBottom: 14 }}


                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter valid Quantity
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>UOM</Typography>
                                        <Form.Select
                                            required
                                            onChange={(e) => setUom(e.target.value)}
                                            type="text"

                                            

                                            style={{ padding: '0.42rem', marginBottom: 14 }}


                                        >
                                            <option>Select UOM</option>

                                            {
                                                response1.map((data,index) => (
                                                    <React.Fragment key={index}>
                                                    {data.UOM.split(',').map((block, blockIndex) => (
                                                        <option key={blockIndex}>{block.trim()}</option>
                                                    ))}
                                                    </React.Fragment>
                                                ))
                                            }
                                            
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid manager
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                   


                                    

                                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                                        <Typography style={{ color: 'gray', fontSize: 13 }}>Supplier bill ref</Typography>
                                        <Form.Control
                                            required
                                            onChange={(e) => setSbr(e.target.value)}

                                            type="text"

                                            style={{ padding: '0.42rem', marginBottom: 14 }}


                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please Enter Valid Description
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Row>
                                <div className='d-flex'>
                                    <div>
                                        <Button type='submit' style={{ width: '9rem', height: '2.3rem', backgroundColor: 'rgb(126, 110, 228)', color: 'white', marginRight: 3 }}>Submit</Button>
                                    </div>
                                    <div>
                                        <Button onClick={() => setOpen(false)} style={{ width: '9rem', height: '2.3rem', backgroundColor: 'gray', color: 'white' }}>Cancel</Button>
                                    </div>
                                </div>
                            </Form>
            
                    </DialogContent>
                </Dialog>
            </div>

            

            <div>
                <Dialog
                    style={{ borderTop: '12px solid rgb(126, 110, 228)' }}
                    maxWidth='md'
                    open={opened}
                    onClose={handleCloseed}
                    aria-labelledby="responsive-dialog-title"
                >

                    <DialogContent>
             
                            <Form noValidate >
                                <div className='mb-4 mt-1'>
                                    <Typography style={{ textAlign: 'center', fontWeight: '500', color: 'rgb(126, 110, 228)', fontSize: 21 }}>Edit Purchase</Typography>
                                    {/* <Typography style={{ textAlign: 'center', fontSize: 15 }}>Addding project details will receive a privacy audit.</Typography> */}
                                </div>
                                <Row className="mb-3">

                                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                                            <Typography style={{ color: 'gray', fontSize: 13 }}>Purchase no </Typography>
                                            <Form.Control
                                                required
                                                onChange={(e) => setPno(e.target.value)}
                                                disabled
                                                type="text"
                                                 value={pno}
                                                style={{ padding: '0.42rem', marginBottom: 14, }}

                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please Enter Valid supplier name
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group as={Col} md="4" controlId="validationCustom01">
                                            <Typography style={{ color: 'gray', fontSize: 13 }}> Date</Typography>
                                            <Form.Control
                                                required
                                                disabled
                                                onChange={(e) => setPdate(e.target.value)}
                                                type="text"
                                                value={`${moment(pdate).format('DD/MM/yyyy')}`}
                                                style={{ padding: '0.42rem', marginBottom: 14 }}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please Enter Valid  date
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group as={Col} md="6" controlId="validationCustom01">
                                            <Typography style={{ color: 'gray', fontSize: 13 }}>Supplier Name</Typography>
                                            <Form.Control
                                                required
                                                value={supName}
                                                onChange={(e) => setSupName(e.target.value)}
                                                
                                                type="text"

                                                style={{ padding: '0.42rem', marginBottom: 14, }}

                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please Enter Valid supplier name
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group as={Col} md="6" controlId="validationCustom01">
                                            <Typography style={{ color: 'gray', fontSize: 13 }}>Product</Typography>
                                            <Form.Select
                                                required
                                                value={product}
                                                onChange={(e) => setProduct(e.target.value)}
                                                type="text"
                                                style={{ padding: '0.42rem', marginBottom: 14 }}
                                            >
                                                <option>Select Product</option>
                                                {
                                                response1.map((data,index) => (
                                                    <React.Fragment key={index}>
                                                    {data.ProductName.split(',').map((block, blockIndex) => (
                                                        <option key={blockIndex}>{block.trim()}</option>
                                                    ))}
                                                    </React.Fragment>
                                                ))
                                            }
                                                
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                Please Enter Valid manager
                                            </Form.Control.Feedback>
                                        </Form.Group>


                                        <Form.Group as={Col} md="6" controlId="validationCustom01">
                                            <Typography style={{ color: 'gray', fontSize: 13 }}>Quantity</Typography>
                                            <Form.Control
                                                required
                                                onChange={(e) => setQty(e.target.value)}
                                                type="text"
                                                value={qty}

                                                style={{ padding: '0.42rem', marginBottom: 14 }}


                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please Enter valid Quantity
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group as={Col} md="6" controlId="validationCustom01">
                                            <Typography style={{ color: 'gray', fontSize: 13 }}>UOM</Typography>
                                            <Form.Select
                                                required
                                                value={uom}
                                                onChange={(e) => setUom(e.target.value)}
                                                type="text"

                                                

                                                style={{ padding: '0.42rem', marginBottom: 14 }}


                                            >
                                                <option>Select UOM</option>

                                                {
                                                response1.map((data,index) => (
                                                    <React.Fragment key={index}>
                                                    {data.UOM.split(',').map((block, blockIndex) => (
                                                        <option key={blockIndex}>{block.trim()}</option>
                                                    ))}
                                                    </React.Fragment>
                                                ))
                                            }
                                                
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                Please Enter Valid manager
                                            </Form.Control.Feedback>
                                        </Form.Group>


                                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                                            <Typography style={{ color: 'gray', fontSize: 13 }}>Supplier bill ref</Typography>
                                            <Form.Control
                                                required
                                                value={sbr}
                                                onChange={(e) => setSbr(e.target.value)}

                                                type="text"

                                                style={{ padding: '0.42rem', marginBottom: 14 }}


                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please Enter Valid Description
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Row>
                                <div className='d-flex'>
                                    <div>
                                        <Button onClick={() => editAlert(id)} style={{ width: '9rem', height: '2.3rem', backgroundColor: 'rgb(126, 110, 228)', color: 'white', marginRight: 3 }}>Update</Button>
                                    </div>
                                    <div>
                                        <Button onClick={handleCloseed} style={{ width: '9rem', height: '2.3rem', backgroundColor: 'gray', color: 'white' }}>Cancel</Button>
                                    </div>
                                </div>
                            </Form>
        
                    </DialogContent>
                </Dialog>
            </div>

        </div>
    );
}